import React, { Component } from 'react';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Edit from '@material-ui/icons/Edit';
import ArchiveIcon from '@material-ui/icons/Archive';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import WebsiteAppointmentRequestViewModal from '../WebsiteAppointmentRequestViewModal';

const PREMIUM_TAB = 0;
const FREEMIUM_TAB = 1;

class WebsiteAppointmentRequests extends Component {
  state = {
    requestUnderEdit: {},
    openAppointmentRequestModal: false,
  };
  onViewAppointmentRequest = request => {
    this.setState({
      requestUnderEdit: request,
      openAppointmentRequestModal: true,
    });
  };

 

  onCloseModal = () => {
    this.setState({
      requestUnderEdit: {},
      openAppointmentRequestModal: false,
    });
  };

  onSave = async appointmentRequest => {
    await this.props.onSaveAppointmentRequest(appointmentRequest);
    this.onCloseModal();
  };

  render() {
    const { openAppointmentRequestModal, requestUnderEdit } = this.state;
    const {
      appointmentRequests,
      tabPosition,
      onArchiveAppointmentRequest,
      pageIndex,
      pageLimit,
      classes
    } = this.props;

    return (
      <>
        <Grid item xs={12}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Requesting Patient (Creator)</TableCell>
                <TableCell>Provider</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Received</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {appointmentRequests.map(appointmentRequest => (
                <TableRow key={appointmentRequest.id}>
                  <TableCell width="250">{appointmentRequest.name}</TableCell>
                  <TableCell width="300">
                    {appointmentRequest.providerName}
                  </TableCell>
                  <TableCell width="300">{appointmentRequest.email}</TableCell>
                  <TableCell width="300">
                    {moment(appointmentRequest.createdAt).format(
                      'MM-DD-YYYY hh:mma'
                    )}
                  </TableCell>
                  <TableCell width="300">
                    {(tabPosition === PREMIUM_TAB ||
                      tabPosition === FREEMIUM_TAB) && (
                      <IconButton
                        onClick={() =>
                          onArchiveAppointmentRequest(appointmentRequest)
                        }
                      >
                        <ArchiveIcon />
                      </IconButton>
                    )}
                    <IconButton
                      onClick={() =>
                        this.onViewAppointmentRequest(appointmentRequest)
                      }
                    >
                      <Edit />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div  className={classes.pageTurners}  >
                <IconButton disabled={pageIndex === 0}>
                  <ArrowBackIosIcon
                    style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={this.props.onPageBack} 
                  />
                </IconButton>
                <IconButton disabled={appointmentRequests.length < pageLimit}>
                  <ArrowForwardIosIcon
                    style={{ opacity: appointmentRequests.length < pageLimit ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={this.props.onPageForward}
                  />
                </IconButton>
              </div>
        </Grid>

        {openAppointmentRequestModal && (
          <WebsiteAppointmentRequestViewModal
            appointmentRequest={requestUnderEdit}
            open={openAppointmentRequestModal}
            save={this.onSave}
            onClose={this.onCloseModal}
          />
        )}
      </>
    );
  }
}

const styles = () => ({
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
    paddingBottom: '0.5em',
  },
  providerImage: {
    width: '40px',
    height: '40px',
    borderRadius: '4px',
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between'
  },
});

export default withStyles(styles)(WebsiteAppointmentRequests);
